<template>
  <div class="joins-details">
    <div class="joins-details-header">
      <div class="joins-details-width joins-details-header-layout">
        <div class="joins-details-header___base">
          <div class="joins-details-header___base-post">
            <h2>{{ recentDetails.jobName }}</h2>
            <p>{{ recentDetails.minSalary }}-{{ recentDetails.maxSalary }}K</p>
          </div>
          <div class="joins-details-header___base-ask">
            <ul>
              <li>
                <img src="@/assets/images/joins/dizhi.png" alt="" />
                <p>{{ recentDetails.workAddress }}</p>
              </li>
              <li>
                <img src="@/assets/images/joins/bumen.png" alt="" />
                <p>{{ recentDetails.department }}</p>
              </li>
              <li>
                <img src="@/assets/images/joins/fenlei.png" alt="" />
                <p>{{ recentDetails.jobCategory }}</p>
              </li>
              <li>
                <img src="@/assets/images/joins/xueli.png" alt="" />
                <p>{{ recentDetails.educationName }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="joins-details-header___classify">
          <ul>
            <template v-for="(name, index) of recentDetails.jobLabel">
              <li v-if="index < 4" :key="index">
                <p>{{ name }}</p>
              </li>
            </template>
            <li
              v-if="recentDetails.jobLabel.length > 4"
              @mouseenter="handlerMouse"
              @mouseleave="handlerMouse"
            >
              <p>......</p>
            </li>
          </ul>
          <Transition name="fade">
            <ul
              v-if="isShowClassify"
              class="joins-details-header___classify-all"
            >
              <template v-for="(item, index) of recentDetails.jobLabel">
                <li v-if="index < 10" :key="index">
                  <p>{{ item }}</p>
                </li>
              </template>
            </ul>
          </Transition>
        </div>
      </div>
    </div>
    <div class="joins-details-main joins-details-width">
      <h2>职位详情</h2>
      <div v-html="recentDetails.content"></div>
      <h3 v-if="recentDetails.pictures.length">公司相册:</h3>
      <div
        v-if="recentDetails.pictures.length"
        class="joins-details-main___swiper"
      >
        <div
          v-if="recentDetails.pictures.length > 2"
          class="joins-details-main___swiper-button joins-details-main___swiper-pre"
          :class="{
            'joins-details-main___swiper-button-show': isShowPreButton,
          }"
          @mouseenter="() => (isShowPreButton = true)"
          @mouseleave="() => (isShowPreButton = false)"
          @click="handlePre"
        >
          <img
            v-show="!isFirst"
            src="@/assets/images/company/left.png"
            alt=""
          />
          <img
            v-show="isFirst"
            src="@/assets/images/company/le-disabled.png"
            alt=""
          />
        </div>
        <swiper ref="swiperRef" :options="swiperOptions">
          <swiper-slide
            class="joins-details-main___swiper-slide-item"
            v-for="(img, index) of recentDetails.pictures"
            :key="index"
          >
            <img
              :src="img"
              @mouseenter="handleSwiperEnter(index)"
              @mouseleave="handleSwiperLeave"
              alt=""
            />
          </swiper-slide>
        </swiper>
        <div
          v-if="recentDetails.pictures.length > 2"
          class="joins-details-main___swiper-button joins-details-main___swiper-next"
          :class="{
            'joins-details-main___swiper-button-show': isShowNextButton,
          }"
          @mouseenter="() => (isShowNextButton = true)"
          @mouseleave="() => (isShowNextButton = false)"
          @click="handleNext"
        >
          <img
            v-show="!isLast"
            src="@/assets/images/company/right.png"
            alt=""
          />
          <img
            v-show="isLast"
            src="@/assets/images/company/ri-disabled.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="joins-details-footer">
      <div class="joins-details-width">
        <div class="joins-details-footer-layout">
          <h2>投递者信息填写</h2>
          <div class="joins-details-footer___content">
            <div class="joins-details-footer___content-item">
              <label for="name">应聘人姓名：</label>
              <input
                type="text"
                id="name"
                maxlength="6"
                v-model="resume.applicantName"
                @input="handleNameChange"
              />
            </div>
            <div class="joins-details-footer___content-item">
              <label for="time">毕业时间：</label>
              <vue-datepicker-local
                v-model="resume.graduateDate"
                format="YYYY-MM"
              ></vue-datepicker-local>
            </div>
            <div class="joins-details-footer___content-item">
              <label for="phone">联系人电话：</label>
              <input
                type="text"
                id="phone"
                maxlength="11"
                v-model="resume.mobile"
                @input="handleChange"
              />
            </div>
            <div class="joins-details-footer___content-item">
              <label for="major">所属专业：</label>
              <input type="text" id="major" v-model="resume.specialty" />
            </div>
            <div class="joins-details-footer___content-item">
              <label for="school">毕业院校：</label>
              <input type="text" id="school" v-model="resume.graduateSchool" />
            </div>
            <div class="joins-details-footer___content-item">
              <label for="education">最高学历：</label>
              <select name="pets" id="education" v-model="resume.maxEducation">
                <option value="">请选择</option>
                <option value="1">大专</option>
                <option value="2">本科</option>
                <option value="3">硕士</option>
                <option value="4">其他</option>
              </select>
            </div>
            <div
              class="joins-details-footer___content-item joins-details-footer___file-row"
              style="width: 100%; position: relative"
            >
              <label for="resumeFile" style="width: 90px">附件上传：</label>
              <div class="input-wapper">
                <div class="input-lf">
                  <span
                    style="font-size: 12px; color: #999999"
                    v-if="!resumeFileName && !ossLoading"
                    >（支持格式：doc、docx、pdf、jpg、jpeg、png，建议附件名称：姓名-岗位-投递日期）</span
                  >
                  <!-- 名字 -->
                  <img
                    src="@/assets/images/upload-icon.png"
                    class="logo"
                    v-if="ossLoading || resumeFileName"
                    alt=""
                  />
                  <span v-if="resumeFileName" class="fileName">{{
                    resumeFileName
                  }}</span>
                  <span v-if="ossLoading" style="margin-left: 10px"
                    >上传中...</span
                  >
                </div>
                <div class="input-rg">
                  <!-- 上传按钮 透明-->
                  <input
                    class="upload-opacity"
                    type="file"
                    style="width: 1px; height: 0px"
                    id="resumeFile"
                    ref="resumeFileInput"
                    accept=".doc,.docx,.pdf,.jpg,.jpeg,.png"
                    @change="handleFileChange"
                  />
                  <!-- 上传按钮样式 -->
                  <div
                    class="upload"
                    @click="$refs.resumeFileInput.click()"
                    @mouseenter="isLinkHover = true"
                    @mouseleave="isLinkHover = false"
                    v-if="!resumeFileName"
                  >
                    <span class="desc">上传附件</span>
                    <!-- 正常展示link.png 鼠标悬浮展示link-activity.png -->
                    <img
                      :src="
                        isLinkHover
                          ? require('@/assets/images/link-activity.png')
                          : require('@/assets/images/link.png')
                      "
                      class="logo"
                      alt=""
                    />
                    <!-- <img
                      src="@/assets/images/link-activity.png"
                      class="logo"
                      alt=""
                    /> -->
                  </div>
                  <!-- 删除按钮 -->
                  <div class="del" @click="handleDelete" v-if="resumeFileName">
                    删除
                  </div>
                </div>
              </div>
            </div>

            <div
              class="joins-details-footer___content-button"
              :class="{ disabled: isProgress }"
              @click="handleSubmit"
            >
              <p>立即投递</p>
            </div>
          </div>
          <p class="joins-details-footer___desc">
            *对该岗位感兴趣的优秀人才，可以预留个人联系方式，后续相关招聘老师会第一时间与您取得联系哦~
          </p>
        </div>
      </div>
    </div>

    <message-box :show.sync="isShowMessage" :message="message"></message-box>
  </div>
</template>

<script>
import VueDatepickerLocal from "@/components/datepicker/VueDatepickerLocal";
import OSS from "ali-oss";
import MessageBox from "./components/MessageBox";

import { stsToken } from "@/api/common/index";
import { addUserResume, getRecentDetailsById } from "@/api/joins";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    VueDatepickerLocal,
    MessageBox,
    swiperSlide,
    swiper,
  },
  computed: {
    isFirst() {
      return this.swiperIndex === 0;
    },
    isLast() {
      return this.swiperIndex === this.recentDetails.pictures.length - 3;
    },
  },
  data() {
    return {
      // 是否显示待遇分类
      isShowClassify: false,
      // 是否显示 消息确认框
      isShowMessage: false,
      // 是否显示 swiper 左按钮
      isShowPreButton: false,
      // 是否显示 swiper 又按钮
      isShowNextButton: false,
      // 是否正在请求接口
      isProgress: false,
      swiperOptions: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 8,
      },
      recentDetails: {
        // 工作地点
        workAddress: "",
        // 岗位名称
        jobName: "",
        // 所属部门
        department: "",
        // 岗位类别
        jobCategory: "",
        // 学历要求
        educationName: "",
        // 福利标签
        jobLabel: [],
        // 公司相册
        pictures: [],
      },
      resume: {
        applicantName: "",
        maxEducation: null,
        mobile: null,
        graduateSchool: "",
        graduateDate: "",
        recruitId: "",
        specialty: "",
      },
      resumeFile: null, // 上传到OSS后的文件地址
      resumeFileName: "", // 上传文件的名称
      ossLoading: false, // oss上传中
      isLinkHover: false,
      message: ``,
      swiperIndex: 0,
      resumeFileInput: null,
    };
  },
  methods: {
    handleDelete() {
      this.resumeFile = null;
      this.resumeFileName = "";
      this.$refs.resumeFileInput.value = "";
    },
    // 获取 OSS 配置信息（建议后端接口返回临时密钥）
    async getOssConfig() {
      // 这里假设你有后端接口返回 OSS 配置
      const { data } = await stsToken();
      console.log("OSS Config:", data);
      return data;
    },
    // 上传到 OSS
    async uploadToOss(file) {
      const config = await this.getOssConfig();
      let expirTime =
        new Date(config.expiration).getTime() - new Date().getTime();
      const client = new OSS({
        region: `${config.endPoint?.split(".")[0]}`,
        accessKeyId: config.accessKeyId,
        accessKeySecret: config.accessKeySecret,
        stsToken: config.securityToken,
        bucket: config.bucketName,
        endPoint: config.endPoint,
        expiration: config.expiration,
        success_action_status: "200",
        "x-oss-security-token": config.securityToken,
        secure: true,
        refreshSTSTokenInterval: expirTime,
      });
      // 生成唯一文件名
      const ext = file.name.split(".").pop();
      const filename = `/img/kukenews/tinymce/pc/${Date.now()}_${Math.floor(
        Math.random() * 10000
      )}.${ext}`;
      try {
        const result = await client.put(filename, file);
        return result.url; // 返回 OSS 文件地址
      } catch (err) {
        console.error("OSS Upload Error:", err);
        this.$message.info("上传失败");
        return "";
      }
    },
    handlerMouse() {
      this.isShowClassify = !this.isShowClassify;
    },
    // 下一个
    handleNext() {
      if (this.isLast || !this.isShowNextButton) return;
      this.$refs.swiperRef.swiper.slideTo(++this.swiperIndex);
    },
    // 上一个
    handlePre() {
      if (this.isFirst || !this.isShowPreButton) return;
      this.$refs.swiperRef.swiper.slideTo(--this.swiperIndex);
    },
    // 控制swiper左右的按钮是否显示
    handleSwiperEnter(index) {
      if (this.swiperIndex === index) this.isShowPreButton = true;
      if (this.swiperIndex + 2 === index) this.isShowNextButton = true;
    },
    // 隐藏swiper按钮
    handleSwiperLeave() {
      this.isShowPreButton = this.isShowNextButton = false;
    },
    // 格式化手机号
    handleChange() {
      if (!this.resume.mobile) return;
      this.resume.mobile = this.resume.mobile.replace(/[^0-9]/gi, "");
    },
    // 名称必须是中文
    handleNameChange() {
      if (!this.resume.applicantName) return;
      this.resume.applicantName = this.resume.applicantName.replace(
        /[^\u4E00-\u9FA5]/g,
        ""
      );
    },
    // 提交招聘信息
    async handleSubmit() {
      this.isProgress = true;
      const list = Object.keys(this.resume).filter((key) => !this.resume[key]);
      // 如果有未添加的数据
      if (list.length) {
        this.$message.info("请填写完所有信息后提交");
        this.isProgress = false;
        return;
      }
      // 手机号不满足11位
      if (
        this.resume.mobile.length !== 11 ||
        !this.resume.mobile.startsWith("1") ||
        this.resume.mobile.includes(".")
      ) {
        this.$message.info("联系方式必须是11位有效手机号");
        this.isProgress = false;
        return;
      }
      //简历名称支持50长度
      if (this.resumeFileName) {
        if (this.resumeFileName.length > 50) {
          this.$message.info("简历名称过长，请控制在50字以内");
          this.isProgress = false;
          return;
        }
      }

      try {
        // 提交
        await addUserResume({
          ...this.resume,
          fileUrl: this.resumeFile,
          fileName: this.resumeFileName,
        });
        this.message = "您已成功投递, <br> 请您保持联系方式畅通噢～";
        this.isShowMessage = true;
      } catch ({ code, msg }) {
        if (code === "10108") {
          this.message = "该岗位您已投递过啦~<br>请您耐心等待/查看其他岗位信息";
          this.isShowMessage = true;
        } else {
          this.$message.info(msg);
        }
      } finally {
        this.isProgress = false;
      }
    },
    // 获取到招聘详细信息
    async getRecentDetails(id) {
      const { data } = await getRecentDetailsById(id);
      this.recentDetails = data;
    },
    // 处理简历文件上传
    async handleFileChange(e) {
      try {
        const file = e.target.files[0];
        if (!file) return;
        // allowedTypes .doc,.docx,.pdf,.jpg,.jpeg,.png 只控制这几种
        const allowedTypes = [
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/pdf",
          "image/jpeg",
          "image/jpg",
          "image/png",
        ];
        // 允许部分浏览器只识别扩展名
        const extAllowed = ["doc", "docx", "pdf", "jpg", "jpeg", "png"];
        const ext = file.name.split(".").pop().toLowerCase();
        if (!allowedTypes.includes(file.type) && !extAllowed.includes(ext)) {
          this.$message.info("仅支持 doc、docx、pdf、jpg、jpeg、png 格式");
          e.target.value = "";
          return;
        }

        // OSS上传
        this.ossLoading = true;
        const ossUrl = await this.uploadToOss(file);
        console.log("OSS URL:", ossUrl);
        if (ossUrl) {
          this.resumeFileName = file.name;
          this.ossLoading = false;
          this.resumeFile = ossUrl; // 保存OSS地址
        }
      } catch (error) {
        this.ossLoading = false;
        this.resumeFileName = "";
        this.$refs.resumeFileInput.value = "";
        console.error("File upload error:", error);
        this.$message.info("上传失败，请重试");
      }
    },
  },
  created() {
    const { params } = this.$route;
    if (!params.id) return;
    this.resume.recruitId = params.id;
    this.getRecentDetails(params.id);
  },
};
</script>

<style lang="less" scoped>
.joins-details {
  padding-top: 80px;

  &-header {
    height: 202px;
    background: url("../../assets/images/joins/bg_gsjs.png") no-repeat;
    background-size: cover;

    &___base {
      padding-top: 40px;

      &-post {
        display: flex;
        color: #fff;

        h2 {
          font-size: 40px;
          font-weight: bold;
        }

        p {
          padding-left: 20px;
          font-size: 42px;
          font-weight: 400;
          line-height: 42px;
        }
      }

      &-ask {
        padding-top: 36px;

        ul {
          display: flex;
          color: #e9a7a1;
          font-size: 18px;
          font-weight: 500;

          li {
            display: flex;
            align-items: center;
            margin-right: 30px;

            img {
              width: 20px;
              height: 20px;
            }

            p {
              margin-left: 8px;
            }
          }
        }
      }
    }

    &___classify {
      position: relative;
      padding-top: 44px;

      ul {
        display: flex;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 36px;
          padding: 0 10px;
          margin-left: 8px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          cursor: pointer;

          p {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }

      &-all {
        padding: 16px 20px;
        position: absolute;
        display: grid !important;
        grid-template-columns: repeat(5, 1fr);
        gap: 10px;
        right: 0;
        margin-top: 10px;
        background: #fff;
        border-radius: 5px;

        li {
          width: 88px !important;
          height: 30px !important;
          background: #faeae9 !important;
          margin-left: 0 !important;

          p {
            font-size: 16px !important;
            color: #d14437 !important;
          }
        }
      }
    }

    &-layout {
      display: flex;
      justify-content: space-between;
    }
  }

  &-main {
    padding: 80px 0 60px 0;

    h2 {
      padding-bottom: 42px;
      font-size: 40px;
      font-weight: bold;
      color: #333333;
    }

    h3 {
      padding: 30px 0 20px 0;
    }

    &___swiper {
      position: relative;

      &-slide-item {
        img {
          width: 392px;
          height: 220px;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      &-button {
        transition: opacity 0.3s;
        opacity: 0;

        &-show {
          opacity: 1;
        }
      }

      &-pre,
      &-next {
        position: absolute;
        top: 50%;
        z-index: 10;
        transform: translateY(-50%);

        img {
          width: 72px;
          height: 72px;
          cursor: pointer;
        }
      }

      &-pre {
        left: -35px;
      }
      &-next {
        right: -35px;
      }
    }
  }

  &-footer {
    height: 616px;
    background: url("../../assets/images/joins/bg_zxns.png") no-repeat;
    background-size: cover;

    &-layout {
      padding-top: 53px;
    }

    h2 {
      font-size: 44px;
      font-weight: 600;
      color: #020723;
    }

    &___content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 40px;
      padding: 40px 70px;
      background: #fff;
      border-radius: 5px;

      &-item {
        display: flex;
        align-items: center;
        padding: 0 20px;
        margin-top: 16px;
        width: 520px;
        height: 50px;
        font-size: 16px;
        background: #f7f7f7;
        border-radius: 2px;

        label {
          font-weight: 400;
          color: #666666;
          width: 22%;
        }

        select,
        input {
          color: #333;
          flex: 1;
          height: 80%;
          font-size: 16px;
          border: transparent;
          background: transparent;
          outline: none;
        }

        select {
          appearance: none;
        }

        .datepicker {
          flex: 1;
        }
      }
      &-file-row {
        width: 100%;
        min-width: 0;
        height: 50px;
        margin-top: 16px;
        background: #f7f7f7;
        border-radius: 2px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-size: 16px;
        label {
          width: 120px;
          min-width: 120px;
        }
        input[type="file"] {
          flex: 1;
          max-width: 300px;
        }
      }

      &-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 50px;
        margin: 20px auto 0;
        background: #cd3324;
        border-radius: 2px;
        cursor: pointer;
        user-select: none;

        p {
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }

    &___desc {
      padding-top: 20px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }
  }

  &-width {
    width: 1200px;
    height: 100%;
    margin: auto;
  }
}
.disabled {
  background: #ccc;
}

.input-wapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  .input-lf {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }
  .input-rg {
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
    .upload-opacity {
      opacity: 0;
      z-index: 999;
      cursor: pointer;
      width: 120px;
    }
    .upload {
      cursor: pointer;
      display: flex;
      align-items: center;
      .desc {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-right: 4px;
      }
    }
    .upload:hover {
      .desc {
        color: #cd3324;
      }
    }
    .del {
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
    .del:hover {
      color: #cd3324;
    }
  }
  .logo {
    width: 20px;
    height: 20px;
  }
}
.fileName {
  margin-left: 10px;
  max-width: 700px;
  font-size: 14px;
  color: #333333;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
